import { Biscuit } from "../../../utils";
import React from "react";
import AvailabilitiesView from "./components/AvailabilitiesView";

export const AvailabilitiesPage = (props) => {
  return (
    <>
      {Biscuit.get("user.is_superuser") === "true" ? (
        <>
          <AvailabilitiesView
            params={props.params}
            returnUrl={props.returnPath}
            dispatch={props.dispatch}
          />
        </>
      ) : (
        <> </>
      )}
    </>
  );
};
